import { from, Observable } from 'rxjs';
import { KeycloakProfile } from 'keycloak-js';
import { KeycloakService } from 'keycloak-angular';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';

import { AuthService } from '../auth.types';
import { AuthContext } from '../auth.helpers';
import { ISS_LOGOUT_URI } from '../auth.config';

import { Account, authActions } from '@iss/wo-common/ngrx';

export class KeycloakAuthService implements AuthService {
  private readonly store = inject(Store);
  private readonly keycloak = inject(KeycloakService);
  private readonly logoutUri = inject(ISS_LOGOUT_URI);

  public bootstrap(): Observable<unknown> {
    return from(this.load());
  }

  private async load(): Promise<void> {
    if (await this.keycloak.isLoggedIn()) {
      this.store.dispatch(authActions.authenticated({
        account: this.toAccount(await this.keycloak.loadUserProfile()),
      }));
    }
  }

  private toAccount({ email, firstName, lastName, username }: KeycloakProfile): Account {
    return {
      email: AuthContext.inferEmail(email),
      username: AuthContext.inferUsername(firstName, lastName, username),
    };
  }

  public logout(): Observable<unknown> {
    return from(this.keycloak.logout(this.logoutUri));
  }

  public isLoggedIn(): Observable<boolean> {
    return from(this.keycloak.isLoggedIn());
  }
}
